package com.sddamico.draftmachine

import com.sddamico.draftmachine.ds.DmColor
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * Legacy site palette, now sourced from the design-system tokens ([DmColor]). Kept because a few
 * placeholder styles still reference it; new work should use [DmColor] directly.
 */
object SitePalette {
    val background = DmColor.bg
    val surface = DmColor.surfacePanel
    val surfaceHover = DmColor.surfaceHover
    val border = DmColor.border
    val primary = DmColor.primary
    val primaryHover = DmColor.primaryHover
    val accent = DmColor.accent
    val accentMuted = DmColor.glass700
    val text = DmColor.text
    val textSecondary = DmColor.textSecondary
    val textMuted = DmColor.textMuted
    val error = DmColor.danger
    val success = DmColor.success
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.dark.background = DmColor.bg
    ctx.theme.palettes.dark.color = DmColor.text
    ctx.theme.palettes.light.background = DmColor.bg
    ctx.theme.palettes.light.color = DmColor.text
}
